import { styled } from '@mui/material/styles';

const StatusTag = ({ status, style }: { status: string; style?: any }) => {
    const statusClass = status?.toLocaleLowerCase().split(' ').join('_');
    return (
        <Tag>
            <StausIcon className={statusClass} />
            <span style={style}>{status}</span>
        </Tag>
    );
};

const Tag = styled('span')({
    display: 'flex',
    alignItems: 'center'
});
const StausIcon = styled('i')({
    display: 'inline-block',
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    marginRight: '5px',
    '&.in_progress': {
        background: '#FFD000'
    },
    '&.completed': {
        background: 'green'
    },
    '&.finalized': {
        background: 'green'
    },
    '&.not_started': {
        background: '#82786F'
    }
});

export default StatusTag;
